import configData from './config.json';

const env = process.env.REACT_APP_ENV || process.env.NODE_ENV || 'development';
const config = configData[env] || configData.development;

export default config;
